/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerContractAddressDto } from './BorrowerContractAddressDto';
import {
    BorrowerContractAddressDtoFromJSON,
    BorrowerContractAddressDtoFromJSONTyped,
    BorrowerContractAddressDtoToJSON,
    BorrowerContractAddressDtoToJSONTyped,
} from './BorrowerContractAddressDto';

/**
 * Subscriber (main borrower) information
 * @export
 * @interface BorrowerSubscriberDto
 */
export interface BorrowerSubscriberDto {
    /**
     * Unique identifier of the person
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    id: string;
    /**
     * Unique identifier of the borrower
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    borrowerId: string;
    /**
     * Civility (e.g. Mr, Mrs)
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    civility?: string | null;
    /**
     * Last name
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    lastName?: string | null;
    /**
     * First name
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    firstName?: string | null;
    /**
     * Birth name
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    birthName?: string | null;
    /**
     * Date of birth
     * @type {Date}
     * @memberof BorrowerSubscriberDto
     */
    birthDate?: Date | null;
    /**
     * Email address
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    email?: string | null;
    /**
     * Phone number
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    phone?: string | null;
    /**
     * Profession
     * @type {string}
     * @memberof BorrowerSubscriberDto
     */
    job?: string | null;
    /**
     * 
     * @type {BorrowerContractAddressDto}
     * @memberof BorrowerSubscriberDto
     */
    address?: BorrowerContractAddressDto;
}

/**
 * Check if a given object implements the BorrowerSubscriberDto interface.
 */
export function instanceOfBorrowerSubscriberDto(value: object): value is BorrowerSubscriberDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    return true;
}

export function BorrowerSubscriberDtoFromJSON(json: any): BorrowerSubscriberDto {
    return BorrowerSubscriberDtoFromJSONTyped(json, false);
}

export function BorrowerSubscriberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerSubscriberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'borrowerId': json['borrowerId'],
        'civility': json['civility'] == null ? undefined : json['civility'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'birthName': json['birthName'] == null ? undefined : json['birthName'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'job': json['job'] == null ? undefined : json['job'],
        'address': json['address'] == null ? undefined : BorrowerContractAddressDtoFromJSON(json['address']),
    };
}

export function BorrowerSubscriberDtoToJSON(json: any): BorrowerSubscriberDto {
    return BorrowerSubscriberDtoToJSONTyped(json, false);
}

export function BorrowerSubscriberDtoToJSONTyped(value?: BorrowerSubscriberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'borrowerId': value['borrowerId'],
        'civility': value['civility'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'birthName': value['birthName'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate'] as any).toISOString()),
        'email': value['email'],
        'phone': value['phone'],
        'job': value['job'],
        'address': BorrowerContractAddressDtoToJSON(value['address']),
    };
}

